import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Axios } from 'api/axios'; // <-- your custom Axios instance
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddUserTypeModal = ({ show, handleClose, onSuccess, editData }: any) => {
  const [formData, setFormData] = useState({ user_type: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const user_type_id = editData?.user_type_id ?? null;
  const isEdit = user_type_id !== null;

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const isValid = /^[A-Za-z\s]*$/.test(value);
    if (isValid) {
      setFormData({ ...formData, [name]: value });
    }
  };



  useEffect(() => {
    if (show) {
      if (isEdit && editData?.user_type) {
        setFormData({ user_type: editData.user_type });
      } else {
        setFormData({ user_type: '' });
      }
    }
  }, [show, isEdit, editData]);


  const handleModalClose = () => {
    setFormData({ user_type: '' });
    handleClose();
  };

  const handleSubmit = async () => {
    if (!formData.user_type.trim()) {
      toast.error('User Type is required');
      return;
    }

    if (!/^[A-Za-z\s]+$/.test(formData.user_type)) {
      toast.error('User Type must contain only letters and spaces');
      return;
    }

    try {
      setLoading(true);
      let response = null;

      if (isEdit) {
        response = await Axios.put(`/api/usertype/edit/${user_type_id}/`, formData);
      } else {
        response = await Axios.post('/api/usertype/create/', formData); // ✅ fixed
      }

      if (response?.status === 200 || response?.status === 201) {
        toast.success(`User Type ${isEdit ? 'Updated' : 'Created'} Successfully`);
        handleModalClose();
        setTimeout(() => {
          navigate('/user-type');
          window?.location?.reload();
        }, 2000);
      }
    } catch (error: any) {
      console.error("User Type API error:", error?.response?.data); // ✅ log actual backend error
      toast.error(
        error?.response?.data?.user_type?.[0] ||
        error?.response?.data?.errors?.user_type?.[0] ||
        error?.response?.data?.message ||
        'Failed to add User Type'
      );
    } finally {
      setLoading(false);
    }
  };


  return (
    <Modal show={show} onHide={handleModalClose} centered contentClassName="custom-modal">
      <Modal.Header className="border-0">
        <Modal.Title className="fw-bold">
          {isEdit ? 'Edit' : 'Add'} User Type
        </Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleModalClose}
        ></button>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="userType" className="form-label fw-medium">
            User Type
          </label>
          <input
            type="text"
            className="form-control custom-input"
            id="userType"
            name="user_type"
            placeholder="Enter User Type"
            value={formData?.user_type}
            onChange={handleChange}
          />
        </div>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button
            variant="outline-secondary"
            style={{
              color: '#878899',
              borderColor: '#B0BAC9',
              backgroundColor: 'transparent',
            }}
            onClick={handleModalClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {isEdit ? 'Update' : 'Create'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddUserTypeModal;
